import React from "react";
import { ExclamationCircleOutlined, CloseOutlined } from "@ant-design/icons";

interface ErrorBannerProps {
  message: string;
  onClose?: () => void;
}

const ErrorBanner: React.FC<ErrorBannerProps> = ({ message, onClose }) => (
  <div className="flex items-center gap-3 mb-4
                  bg-rose-50 border border-rose-200 rounded-xl
                  px-4 py-3 text-sm text-rose-700">
    <ExclamationCircleOutlined className="text-rose-500 text-base flex-shrink-0" />
    <span className="flex-1">{message}</span>
    <button
      onClick={onClose}
      className="w-6 h-6 flex items-center justify-center rounded-lg
                 bg-rose-100 hover:bg-rose-200 text-rose-500
                 border-none cursor-pointer
                 hover:rotate-90 transition-all duration-200"
    >
      <CloseOutlined style={{ fontSize: 10 }} />
    </button>
  </div>
);

export default ErrorBanner;